import { createConcurrentCustomMetric } from '../../metricConfigs';
import { TIME_TO_APP_IDLE_KEY } from '../../metric-keys';

export const TIME_TO_APP_IDLE_METRIC = createConcurrentCustomMetric({
	key: TIME_TO_APP_IDLE_KEY,
});
